export type TotalEditingMode = 'inactive' | 'criteria' | 'feedback';

export const eq = (a: number, b: number) => a === b;

export function addOne(n: number) {
  return n + 1;
}
